<template>
    <div class="alert-error">
        <img src="../../../../public/img/icons/alert_error.png" alt="" class="img-error">
        <p class="text-error">{{ textError }}</p>
    </div>
</template>
<script>
export default {
    name: 'alert-error',
    props: {
        textError : {
            type : String,
            required : true
        }
    }
}
</script>
<style lang="scss" scoped>
    .alert-error{
        z-index: 10;
        background-color: rgba(0, 0, 0, 0.534);
        width: 100%;
        height: 100%;
        position: fixed;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .img-error{
            height: 150px;
        }

        .text-error{
            
            color: white;
            margin-top: 20px;
            letter-spacing: 2px;
            font-weight: bold;
            text-transform: uppercase;  
            text-align: center;
            width: 80%;
            line-height: 20px;
            font-size: 13px;
        }
    }
</style>
